/* TICKETS PAGE */
Vue.component('ticketmanager',{
    template:'#ticketmanager-template',
    data:function() {
        return {
            moment: moment,
            client: [],
            project: [],
            activeTab:'personaldata',
            backupRecord:[],
            password:'',
            password_verify:'',
            passwordFieldIsActive:false,
            brands:[],
            subBrands:[],
            activeClient:{
                id: -1
            },
            activeClientId: -1,
            activeBrand: '',
            activeBrandId: -1,
            activeSubBrand: {
                id: -1
            },
            activeSubBrandId: -1,
            projectName: '',
            projectDeadLine: '',
            projectStart: '',
            tickets: [],
            recentProjectNumbers: [],
            projectnumbersearchstring: '',
            ticket_name_search_string: '',
            ticketProjectSearch: '',
            loaderIsActive: true,
            showByStatus: 'open',
            showByStatusSecond:'open',
            current_user_id:-1,
            clients: [],
            searchString: '',
            divisions: [],
            activeDivisionId: '',
            activeUserId: '',
            users: [],
            orderDirection: 1,
            deadlineSort: false,
            orderType: "ticket.name",
            status_filter: "open",
            user_is_moderator:false
        };
    },
    watch: {
        deadlineSort: function() {
            this.orderType = (this.deadlineSort) ? 'ticket.deadline' : 'ticket.name';
            if(activeInstance.deadlineSort == false) {
                activeInstance.orderDirection=1;
            }
            else {
                activeInstance.orderDirection=1;
            }
        }
    },
    created:function(){
        activeInstance = this;
        var id = $('#content_wrapper').attr('data-id');

        this.getClients();
        setTimeout(function(){
            $(function () {
                $('#datetimepicker5').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });
                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });
                //SET CURRENT USESR ID BASED ON HIDDEN INPUT IN TEMPLATE
                activeInstance.current_user_id = $("#current_user_id").val();
                activeInstance.user_is_moderator = $('#user_is_moderator').val();

            });

            activeInstance.getUserTickets();
            activeInstance.getDivisions();
            activeInstance.getUsers();
        },500);
    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data) {
            //console.log(data);
            activeInstance.activeClient = data;
            activeInstance.getClientBrands(data.id);
        }
    },
    methods: {
        ticketsFilter: function(arr) {
            console.log(arr);
            var new_arr = JSON.parse(JSON.stringify(arr)),
                that = activeInstance;

            var client_id = parseInt(that.activeClient.id, 10),
                brand_id = parseInt(that.activeBrandId, 10),
                sub_brand_id = parseInt(that.activeSubBrandId, 10),
                user_id = parseInt(that.activeUserId, 10),
                division_id = parseInt(that.activeDivisionId, 10);

            if (client_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.ticket.project.client_id == client_id;
                });
            } else if(client_id == -1) {
                new_arr = new_arr.filter(function(item) {
                    return item.ticket.project.client_id >0;
                });
            }

            if (brand_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.ticket.project.brand_id == brand_id;
                });
            } else if(brand_id == -1) {
                new_arr = new_arr.filter(function(item) {
                    return item.ticket.project.brand_id > 0;
                });
            }

            if (sub_brand_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.ticket.project.sub_brand_id == sub_brand_id;
                });
            } else if(sub_brand_id == -1) {
                new_arr = new_arr.filter(function(item) {
                    return item.ticket.project.sub_brand_id > 0;
                });
            }

            if (division_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.ticket.project.division_id == division_id;
                });
            }

            if (user_id > 0) {
                new_arr = new_arr.filter(function(item) {
                    return item.ticket.supervisor_user_id == user_id;
                });
            }

            if (this.ticketProjectSearch.length > 0) {
                new_arr = new_arr.filter(function(item) {
                    if (item.ticket.project.name.toLowerCase().indexOf(activeInstance.ticketProjectSearch.toLowerCase()) > -1) {
                        return true;
                    } else {
                        return item.ticket.name.toLowerCase().indexOf(activeInstance.ticketProjectSearch.toLowerCase()) > -1
                    }
                });
            }

            return new_arr;
        },
        onClientChange: function(data){
            //activeInstance.activeClient = data;
            activeInstance.getClientBrands(activeInstance.activeClient.id);
        },
        getClients: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/client/list/all')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    activeInstance.clients = response.data;
                }).catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        showAll:function(){
            activeInstance.showByStatus = 'open';
            activeInstance.showByStatusSecond = 'closed';
            //activeInstance.getUserProjects('all');
        },
        showActive:function(){
            activeInstance.showByStatus = 'open';
            activeInstance.showByStatusSecond = 'open';
            //activeInstance.getUserProjects('active');
        },
        closeTicket:function(ticket){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/ticket/close', {
                'ticket_id':ticket.id
                }).then(function (response) {
                    console.log(response);
                    ticket.status='closed';
                    setTimeout(function(){
                        $('body').LoadingOverlay("hide");
                    },200);

                }).catch(function (error) {
                    console.log(error);
                    $('body').LoadingOverlay("hide");
                });
        },
        goToTicketPage:function(project,ticket){
            location.href=baseURL+'/admin/project/'+project.id+'/ticket/'+ticket.id;
        },
        getDivisions: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/divisions/get/active').then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.divisions = response.data;
            }).catch(function (error) {
                console.log(error);
                $('body').LoadingOverlay("hide");
            });
        },
        getUsers: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/users/active').then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.users = response.data;
            }).catch(function (error) {
                console.log(error);
                $('body').LoadingOverlay("hide");
            });
        },
        getUserTickets:function(){

            activeInstance.loaderIsActive=true;
            showLoadingOverlay();

            var url =  baseURL + '/ajax/ticket/list';

            Vue.http.get(url, function(response){
                $('body').LoadingOverlay("hide");

                activeInstance.tickets = response;
                activeInstance.loaderIsActive=false;
            });
        },
        getAllProjectsForCurrentYear:function(){
            activeInstance.loaderIsActive=true;
            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/projects/list/all', function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.projects = response;
                activeInstance.loaderIsActive=false;
            });
        },
        edit:function(project){
            location.href = baseURL+'/admin/project/edit/'+project.id;
        },
        close:function(project){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/close', {
                'project_id':project.id
            }).then(function (response) {
                    console.log(response);
                    project.status='closed';
                    $('body').LoadingOverlay("hide");
                }).catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);

                });
        },
        editTicket:function(project,ticket){
            location.href = baseURL+'/admin/project/'+project.id+'/edit/ticket/'+ticket.id;
        },
        /*
        destroy:function(project){
            bootbox.confirm('Biztosan el akarod távolítani ezt a projektet?', function(value){
                if(value==true){
                    Vue.http.post(baseURL+'/admin/project/destroy',{project:project}).then(function(response){
                        successNotification('A projekt törölve.');
                        activeInstance.projects.$remove(project);
                    });
                }
            });
        },
        */
        createTicket:function(project){
            location.href=baseURL+'/admin/project/'+project.id+'/create/ticket';
        },
        //GET BRANDS BELONGS TO A CLIENT
        getClientBrands:function(id){
            activeInstance.activeBrandId='-1';
            activeInstance.activeBrand=[];
            activeInstance.activeSubBrandId='-1';
            activeInstance.activeSubBrand=[];
            activeInstance.$http.get(baseURL+'/api/brand/list/client/'+activeInstance.activeClient.id).then(function(response){
                activeInstance.brands = response.data;
                activeInstance.subBrands = [];
                activeInstance.activeSubBrandId='-1';
            }).bind(this);
        },

        //WHEN SELECTING A BRAND -> GET THE BELONGING SUB BRANDS
        getBrandSubBrands:function(event,data){
            var activeBrand = $(event.target).val();
            activeInstance.activeBrandId = activeBrand;

            activeInstance.subBrands = [];
            activeInstance.activeSubBrandId='-1';

            $.each(activeInstance.brands, function(index,brand){
                console.log('searching...');

                if(brand.id==activeInstance.activeBrandId){
                    console.log('found...');
                    activeInstance.activeBrand = brand;
                }
            });

            activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrandId).then(function(response){
                //console.log(response);
                activeInstance.subBrands = response.data;
            }).bind(this);
        },
        setActiveSubBrand:function(event){
            var subBrandId = $(event.target).val();
            $.each(activeInstance.subBrands, function(index,sub_brand){
                console.log('searching...');

                if(sub_brand.id==subBrandId){
                    console.log('found...');
                    activeInstance.activeSubBrand = sub_brand;
                }
            });
        }
    }
});